import {ReactNode, Suspense, useContext} from 'react'
import { Navigate } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import {AuthContext} from "../context/AuthContext.tsx";
import {ErrorState} from "../components/ErrorState.tsx";
import {Loader} from "../components/Loader.tsx";

type Props = {
    children: ReactNode
}

export const PublicRoute = (props: Props) => {
    const { children } = props

    const { isAuthenticated, user, loadingUserData } = useContext(AuthContext)

    // While user data is loading, show loader so we don't prematurely redirect
    if (loadingUserData) {
        return <Loader />
    }

    // Only redirect authenticated users when we actually have a user object
    // This prevents a loop where a token exists but user details failed to load
    if (isAuthenticated && user) {
        return <Navigate to="/" />
    }

    return (
        <ErrorBoundary
            fallback={<ErrorState/>}
        >
            <Suspense fallback={<Loader />}>{children}</Suspense>
        </ErrorBoundary>
    )
}
